import React, { useEffect, useState } from 'react'
import DeliveryBankDetail from './DeliveryBankDetail'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import delivaApiService from '../../../common/services/apiService';
import { Col, Row } from 'react-bootstrap';
import Sidebar from '../commonAdmin/Sidebar';
import Header from "../commonAdmin/Header";


const DeliveryAgentBankDetail = (props) => {
  const location = useLocation();
  const [profileDetail, setProfileDetail] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const history = useHistory()


  useEffect(() => {
    const { profileDetail } = location.state || {};
    if (profileDetail) {
      getDeliveryAgentProfile(profileDetail?.userId);
    }
  }, []);


  const getDeliveryAgentProfile = (id) => {
    setShowLoader(true);
    delivaApiService("deliveryAgentprofile", { daId: id })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setProfileDetail(data);
        }
      })
      .catch(() => {
        setShowLoader(false);
      });
  };



  return (
    <div className="page__wrapper h-100">
      <Header {...props} />

      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />

          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                <h3 className="font-weight-normal mb-2  fs-24 color-33 ">Bank Verification</h3>
                {showLoader ? (
                  <p>Loading...</p>
                ) : (
                  <DeliveryBankDetail
                    profileDetail={profileDetail}
                    getDeliveryAgentProfile={getDeliveryAgentProfile}
                  />
                )}
                <button
                  className="b1-btn min-w-80"
                  onClick={() => history.push("/deliveryPartnerProfile")}
                >
                  Back
                </button>{" "}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>



  )
}

export default DeliveryAgentBankDetail
